import React from 'react';
import { PanelStat } from '../panel/panel';

export const KanbanPanelHeader = (props) => {
    return (
        <div className={'panel-heading ' + props.className}>
            <h4 className="panel-title">{props.children}</h4>
            {(!props.noButton &&
                <PanelStat.Consumer>
                    {({ toggleExpand, toggleRemove, toggleCollapse, moveLeft, moveRight }) => (
                        <div className="panel-heading-btn">
                            {props.showLeft ?
                                <>
                                    <button className="btn btn-xs btn-icon btn-circle btn-default" onClick={async () => await moveLeft()}><i title='Move Left' className={!props.isMobile ? "fa fa-arrow-left" : "fa fa-arrow-up"}></i></button>&nbsp;&nbsp;
                                </>
                                : <></>
                            }
                            {props.showRight ?
                                <>
                                    <button className="btn btn-xs btn-icon btn-circle btn-default" onClick={async () => await moveRight()}><i title='Move Right' className={!props.isMobile ? "fa fa-arrow-right" : "fa fa-arrow-down"}></i></button>&nbsp;&nbsp;
                                </>
                                : <></>
                            }
                            <button className="btn btn-xs btn-icon btn-circle btn-default" onClick={toggleExpand}><i className="fa fa-expand"></i></button>&nbsp;&nbsp;
                            <button className="btn btn-xs btn-icon btn-circle btn-warning" onClick={toggleCollapse}><i className="fa fa-minus"></i></button>&nbsp;&nbsp;
                            {props.showDelete ?
                                <>
                                    <button className="btn btn-xs btn-icon btn-circle btn-danger" onClick={async () => await toggleRemove()}><i className="fa fa-times"></i></button>
                                </>
                                : <></>
                            }
                        </div>
                    )}
                </PanelStat.Consumer>
            )}
        </div>
    );
}